<template>
  <v-container style="width: 100%;">
    <v-layout justify-space-between>
      <h1>Aryvo Integration</h1>
    </v-layout>
    <v-layout pt-3 justify-center>
      <v-flex xs12 md8>
        <SimpleCard>
          <v-layout column>
            <p><b>API KEY:</b> {{aryvo_config.api_key}}</p>
            <v-text-field v-model="aryvo_config.url"></v-text-field>
            <v-btn
             large
              class="text-none"
              dark
              color="green"
              placeholder="ARYVO URL"
              @click="initialise"
            >Update URL</v-btn>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import FixedCostList from "@/components/settings/pricing/FixedCostList.vue";
import SimpleCard from "@/components/widget/SimpleCard";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "aryvo_config",
  components: {
    Overview,
    SimpleCard,
    FixedCostList
  },
  data: function() {
    return {
      aryvo_config: {
        url: "",
        api_key: ""
      }
    };
  },
  computed: {
    
  },
  methods: {
    initialise: async function() {

      var url = `${this.$store.state.apiUrl}/aryvo_config/initialise?url=${encodeURIComponent(this.aryvo_config.url)}`;

      let response = await axios.post(url, {
        params: {}
      });

      this.aryvo_config.url = response.data.aryvo_config.url;
      this.aryvo_config.api_key = response.data.aryvo_config.api_key;
   
    }
  },
  mounted: async function() {
    try {
      var url = `${this.$store.state.apiUrl}/aryvo_config/get`;

      let response = await axios.get(url, {
        params: {}
      });

      this.aryvo_config.url = response.data.aryvo_config.url;
      this.aryvo_config.api_key = response.data.aryvo_config.api_key;
    } catch (error) {
      this.loading = false;
      console.log("Failed to get aryvo config");
    }
  }
};
</script>
